import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {ConfigurationModel} from '../../models/configuration.model';
import {ConfigurationService} from '../../services/configuration.service';

@Component({
    selector: 'sign-now-or-later',
    templateUrl: './sign-now-or-later.component.html',
    styleUrls: ['./sign-now-or-later.component.scss'],
})
export class SignNowOrLaterComponent implements OnInit {

    @Input() document: DocumentModel;
    private config: ConfigurationModel;

    constructor(private configurationService: ConfigurationService) {
    }

    ngOnInit() {
        this.config = this.configurationService.getConfiguration();
        // if (this.document.signLater === null) {
        //     if (this.document.documentNumber !== 0) {
        //         this.document.signLater = false;
        //     }
        //     if ((this.document.documentNumber === 0 && this.document.queuedToOperatorId)) {
        //         this.document.signLater = true;
        //     }
        // }
    }

    updateOperator() {
        if (this.document.signLater === null) {
            this.document.signLater = false;
        }
        // this.document.signLater = !this.document.signLater;
        if (this.document.signLater) {
            this.document.queuedToOperatorId = this.config.selectedOperator;
        } else {
            this.document.queuedToOperatorId = null;
        }
    }
}
